import React from 'react';

const yellowTitleRegexGlobal = /\*.*?\*/g; // matches *desired yellow awards title text*
const yellowTitleCaptureRegex = /\*(.*?)\*/; // captures *desired yellow awards title text*
const yellowItalicRegexGlobal = /\|.*?\|/g; // matches |desired yellow italic chronicle text|
const yellowItalicCaptureRegex = /\|(.*?)\|/; // captures |desired yellow italic chronicle text|
const gothamBlackRegexGlobal = /\+.*?\+/g; // matches +desired title text+
const gothamBlackCaptureRegex = /\+(.*?)\+/; // captures +desired title text+

const SPLIT_CHAR = '%%&&';

const generateStyledOutput = () => (potentialStyledOutput, index) => {
  const yellowTitleMatchResult = potentialStyledOutput.match(
    yellowTitleCaptureRegex
  ); // yields *desired yellow awards title text*
  const yellowItalicMatchResult = potentialStyledOutput.match(
    yellowItalicCaptureRegex
  ); // yields |desired yellow italic chronicle text|
  const gothamBlackMatchResult = potentialStyledOutput.match(
    gothamBlackCaptureRegex
  ); // yields +desired yellow italic chronicle text+

  if (gothamBlackMatchResult) {
    const copy = gothamBlackMatchResult[1];

    return (
      <span className="gotham-black__content" key={`gotham-black-${index}`}>
        {copy}
      </span>
    );
  }

  if (yellowTitleMatchResult) {
    const copy = yellowTitleMatchResult[1];

    return (
      <span className="yellow-title__content" key={`yellow-title-${index}`}>
        {copy}
      </span>
    );
  }

  if (yellowItalicMatchResult) {
    const copy = yellowItalicMatchResult[1];

    return (
      <span
        className="yellow-title-italic__content"
        key={`yellow-title-italic-${index}`}
      >
        {copy}
      </span>
    );
  }

  // content is not in styled format!
  return potentialStyledOutput;
};

export default (content) => {
  if (typeof content === 'string') {
    // Wrap all styled output in a split character
    const bookmarkedString = content
      .replace(
        yellowTitleRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      )
      .replace(
        gothamBlackRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      )
      .replace(
        yellowItalicRegexGlobal,
        (match) => `${SPLIT_CHAR}${match}${SPLIT_CHAR}`
      );
    // Split on split char and map everything you can to styled output
    const result = bookmarkedString
      .split(SPLIT_CHAR)
      .map(generateStyledOutput());
    return result;
  }

  // not parsable
  return content;
};
